import * as zExt from "@redotech/rpc/ext";
import { shopperAgentStrategyIdFormat } from "@redotech/shopper-agent-strategy-id";
import * as z from "zod";

export const getShopperAgentStrategy = {
  name: "getShopperAgentStrategy" as const,
  description:
    "Reads the guidance of one Commerce Agent strategy: the instructions a Start Agent Conversation step gives the agent for its outreach and replies. The step's configuration names its strategy id (sst_…).",
  mutates: false,
  input: z.object({ strategyId: shopperAgentStrategyIdFormat.schema }),
  output: z.object({
    /** Missing from servers that predate the unified field. */
    guidance: z.string().optional(),
    goalGuidance: z.string(),
    outreachGuidance: z.string(),
    mongoDiscountId: zExt.objectId().nullable(),
  }),
};
